<app-confirm-dialog></app-confirm-dialog>
<router-outlet></router-outlet>
<p-toast
  position="top-right"
  [autoZIndex]="true"
  [life]="5000">
</p-toast>
